import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Clients from '@/features/clients'

export const Route = createFileRoute('/_authenticated/clients/')({
  component: Clients,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Clients`,
      },
    ],
  }),
})
